module.exports = __webpack_public_path__ + "img/03_zhCn.5b9f7c15.png";